import { lazy } from "react";
import IRoute from "./IRoute";

const ViewMatchesPage = lazy(() => import("../pages/Matches/ViewMatchesPage"));

const matchesRoutes: IRoute = {
  path: "/matches",
  redirect: "/matches/view",
  children: [
    {
      path: "/view",
      component: ViewMatchesPage,
      needAuth: true,
    },
  ],
};

export default matchesRoutes;
